import React, { Component, setState } from 'react'
import { Link } from "react-router-dom";

import { Trans } from "react-i18next";
import {MessageCircle} from "react-feather"


class Notifications extends Component {
    
    
    constructor(props) {
	super(props);
	this.state = {isOpen: false}
    }

    componentDidMount() {
//	setState({isOpen: false})
	document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
	document.removeEventListener('mousedown', this.handleClickOutside);
    }


    handleClickOutside(){
	setState({isOpen: false})
    }
    
    render(){
	const {isOpen} = this.state;
	
	return (
	    <div className="notifications-indicator">
		<button  onClick={()=> this.setState({isOpen: !isOpen})} className="content_button">
		    <MessageCircle />
		    <span className="indicator">4</span>
		</button>
		<div className="notifications-box" style={{display: isOpen ? "block" : "none"}}>
		    <ul>
			<li>Nuovi aggiornaemtni per azienda flag negatività</li>
		    </ul>
		</div>
		
	    </div>
	)
    }
}



export default Notifications
